"use client";
import React, { useState } from "react";
import Image from "next/image";
// import TIme from '../../../../public/updated-home/states/florida/beauty.png'
// import Cinvince from '../../../../public/updated-home/states/florida/Wilderness.png'
// section 1
const ReadMore = ({ children }) => {
  const text = children;
  const [isReadMore, setIsReadMore] = useState(true);

  // Toggle the Read More state
  const toggleReadMore = () => {
    setIsReadMore(!isReadMore);
  };

  // rohailjohn
  return (
    <>
      <div
        className={`${isReadMore ? "line-clamp-5" : ""} overflow-hidden`}
        style={{
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          textOverflow: "ellipsis",
          whiteSpace: "normal",
        }}
      >
        {/* {text} */}
        <p
          dangerouslySetInnerHTML={{ __html: text }}
          className="updatedparapremu pt-6"
        ></p>
      </div>
      {text.length > 380 && (
        <div
          onClick={toggleReadMore}
          className="style-redmore"
          style={{
            color: "#D5AF34",
            fontSize: "17px",
            display: "inline-block",
            marginLeft: "1px",
            cursor: "pointer",
          }}
        >
          {isReadMore ? "Read More" : "Show less"}
        </div>
      )}
    </>
  );
};
function section1({ Mydata }) {
  const data = Mydata[1];

  return (
    <div className="mb-10 ">
      <div className="mx-auto px-6 pt-10 max-w-7xl">
        <div className=" grid grid-cols-5 lg:gap-10">
          <div className=" mb-4 col-span-12 sm:col-span-12 md:col-span-12 lg:col-span-2">
            <Image
              src={data.image}
              height={200}
              width={1900}
              alt={data.alt}
              title={data.tle}
              loading="lazy"
            />
          </div>

          <div className="mb-3 col-span-12  sm:col-span-12 md:col-span-12 lg:col-span-3">
            <h2 className="text-4xl secondary font-bold">
              <span>{data.title}</span>
              {""}
              <span className="text-[#D5AF34]">{data.subtitle}</span>
            </h2>

            <div className="display">
              <p
                dangerouslySetInnerHTML={{ __html: data.des }}
                className="updatedparapremu display pt-6"
              ></p>
              {/* <p className="updatedparapremu pt-6">{data.des}</p> */}
            </div>

            <div className="display-desktop">
              <ReadMore maxLines={5}>{data.des}</ReadMore>
            </div>
          </div>

        </div>
        <div
          key={data.name}
          className="flex flex-col-reverse lg:grid lg:grid-cols-12 lg:items-center lg:gap-x-8"
        >
          <div className="mt-4 lg:col-span-5 lg:mt-0 xl:col-span-7">
            <h2 className="text-4xl secondary font-bold">
              <span>{data.title1}</span>{" "}
              <span className="text-[#D5AF34]">{data.subtitle1}</span>
            </h2>
            <div className="display">
              <p
                dangerouslySetInnerHTML={{ __html: data.des1 }}
                className="updatedparapremu display pt-6"
              ></p>
              {/* <p className="updatedparapremu pt-6">{data.des}</p> */}
            </div>

            <div className="display-desktop">
              <ReadMore maxLines={5}>{data.des1}</ReadMore>
            </div>
          </div>
          <div className="flex-auto col-span-12 sm:col-span-12 md:col-span-12 lg:col-span-5">
            <div id="visionh2" className="">
              <Image
                src={data.image1}
                height={400}
                width={1200}
                alt={data.alt1}
                title={data.tle1}
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default section1;
